export const GenreType = {
  CONTENT: 'CONTENT',
  MUSIC: 'MUSIC',
} as const;

export type GenreType = typeof GenreType[keyof typeof GenreType];

export interface Genre {
  genreId: string;
  name: string;
  nameMm: string;
  description: string;
  iconUrl?: string;
  colorCode: string;
  isActive: boolean;
  sortOrder: number;
  genreType: GenreType;
  contentCount: number;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface GenreCreateRequest {
  name: string;
  nameMm?: string;
  description?: string;
  genreType?: GenreType;
  colorCode?: string;
  isActive?: boolean;
  sortOrder?: number;
  iconUrl?: string;
}

export interface GenreUpdateRequest {
  name?: string;
  nameMm?: string;
  description?: string;
  genreType?: GenreType;
  colorCode?: string;
  isActive?: boolean;
  sortOrder?: number;
  iconUrl?: string;
}

export interface GenresQueryParams {
  page?: number;
  size?: number;
  search?: string;
  isActive?: boolean;
  genreType?: GenreType;
}

export interface GenresData {
  items: Genre[];
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}
